import axios from 'axios';
import { showToastDefault } from '../components/EpToaster';

const httpService = () => {
  const get = async ({
    url, data, hasSuccessToaster, hideErrorToaster, toasterTitle, toasterDescription,
  }) => {
    try {
      const response = await axios.get(url, { params: data });
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response;
    } catch (error) {
      if (!hideErrorToaster) { showToastDefault(error, toasterTitle, toasterDescription); }
      return error;
    }
  };

  const post = async ({
    url, data, hasSuccessToaster, hideErrorToaster, toasterTitle, toasterDescription,
  }) => {
    try {
      const response = await axios.post(url, data);
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response;
    } catch (error) {
      if (!hideErrorToaster) { showToastDefault(error, toasterTitle, toasterDescription); }
      return error;
    }
  };

  const put = async ({
    url, data, hasSuccessToaster, hideErrorToaster, toasterTitle, toasterDescription,
  }) => {
    try {
      const response = await axios.put(url, data);
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response;
    } catch (error) {
      if (!hideErrorToaster) { showToastDefault(error, toasterTitle, toasterDescription); }
      return error;
    }
  };

  const remove = async ({
    url, data, hasSuccessToaster, hideErrorToaster, toasterTitle, toasterDescription,
  }) => {
    try {
      const response = await axios.delete(url, data);
      if (hasSuccessToaster) { showToastDefault(response, toasterTitle, toasterDescription); }
      return response;
    } catch (error) {
      if (!hideErrorToaster) { showToastDefault(error, toasterTitle, toasterDescription); }
      return error;
    }
  };

  return {
    get, post, put, remove,
  };
};

export default httpService;
